import React, { useEffect, useState } from 'react';
import logoColor from '../../common/media/cc_logo_color.svg';
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logo from "../../common/media/cc_logo_white.svg";
import MerchantImpactTicker from "./Ticker/MerchantImpact.js";
import FAQ from "./FAQ/Faq.js";
import * as impact from '../../common/api/impact';

import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration';

const LandingPage = ({ merchantCode }) => {
  
  const [fetchedImpact, setfetchedImpact] = useState();
  const [updatedTimeout, setUpdatedTimeout] = useState(null);

  useEffect(() => {


    impact.merchants(merchantCode, null) // fetch initial impact
      .then(response => response.json())
      .then(body => {
        setfetchedImpact(body)
      })
      .catch(error => {
        console.error(error);
        setfetchedImpact(error)
      })
  }, []);

  const recurrentUpdateFetchedImpact = () => {
    return impact.merchants(merchantCode, null) // fetch updated impact
        .then(response => response.json())
        .then(body => {
          setUpdatedTimeout(setTimeout(recurrentUpdateFetchedImpact, 5000));
          setfetchedImpact(body)
        })
        .catch(error => {
          setUpdatedTimeout(setTimeout(recurrentUpdateFetchedImpact, 5000));
          console.error(error)
        })
        .finally()
  };

  useEffect(() => {
    if(fetchedImpact && !updatedTimeout){
        recurrentUpdateFetchedImpact();
        return () => clearInterval(updatedTimeout);
    }
},[fetchedImpact]);

  return (
    <div className="App">
      <header className="h-85vh w-100 position-relative img-cover vertical-align-parent header-img d-inline-block bg-primary">
        <div className="container color-white text-left vertical-align">
          <div className="row">
            <div className="col-7 mobile-hide">

              <h1 className="mb-4 text-shadow">Round Theory has <br /> gone climate friendly.</h1>
              <h3 className="mb-4 text-shadow">Sustainably sourced &amp; grown, consciously crafted wines.</h3>
             
                <div className="d-flex">
                  <h5 className="mr-2 mt-1 font-bold">Climate Positive by</h5>
                  <div>
                    <img style={{ height: 30 }} src={logo} />
                  </div>
                </div>
            
            </div>
            <div className="mobile-show text-center p-3">
              <h4 className="mb-3 text-shadow font-bold"><span>Round Theory has gone climate friendly.</span></h4>
              <h4 className="mb-3 text-shadow">Sustainably sourced &amp; grown, consciously crafted wines.</h4>
              <img className="mw-100 w-240px" src="https://res.cloudinary.com/carbonclick/image/upload/v1613084276/Enterprise/Round%20Theory%20/Hero_miyvgx.png" />
            </div>
            <div className="position-absolute right-abs mobile-hide" style={{ top: "-70px" }}>
              <img src="https://res.cloudinary.com/carbonclick/image/upload/v1613084276/Enterprise/Round%20Theory%20/Hero_miyvgx.png" />
            </div>
          </div>
        </div>
      </header>

      <section className="py-5 mobile-py-3" id="content">
        <div className="container text-center">
          <div className="mb-4 center mw-800px">
            <h2 className="mb-4 font-bold color-primary">Round Theory is helping to<br />save the planet!</h2>
            <h4 className="mb-4">Round Theory is fighting climate change by reducing the carbon impact of making our wine. For the emissions we can’t reduce, we partner with CarbonClick to offset them, using carbon credits and tree planting.</h4>

            <div className="py-4">

              {
                fetchedImpact && fetchedImpact.carbonOffsetImpact ?
                  <MerchantImpactTicker fetchedImpact={fetchedImpact} />
                  : fetchedImpact && fetchedImpact.error ?
                    <div style={{ textAlign: "center" }}>Could not load impacts, please try again later.</div>
                    : <span>Loading Impact</span>
              }
            </div>

          </div>
        </div>
      </section>

      <section className="py-5 mobile-py-3 bg-secondary color-secondary">
        <div className="container text-center">
          <div className="center mw-800px">
            <h3 className="font-bold mt-0 mb-4">Learn more about what makes<br />Round Theory Climate Positive</h3>

            <iframe className="w-100 mb-4" height="440" src="https://player.vimeo.com/video/479686914" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>

            <div className="center mw-600px">
              <h5 className="mb-3 font-bold">The planet can’t wait any longer. Our climate is being affected by human activity, and the science tells us we’re running out of time. Luckily, there’s a movement happening around the world. Businesses and individuals are waking up and rising to the challenge. We’re proud to be part of Round Theory’s sustainability journey.</h5>
              <a href="/learn-more" className="btn btn-primary">Learn More</a>
            </div>

          </div>
        </div>
      </section>

      <section className="py-6 mobile-py-3">
        <div className="container text-center">
          <h3 className="font-bold mt-0 mb-5 color-primary">Climate Positive FAQs</h3>
          <div className="center mw-800px text-left">
            <FAQ />
          </div>
        </div>
      </section>

      <section>
        <div className="bg-white container pt-4 py-5 position-relative mobile-py-3">
          <div className="mw-800px center">
            <div className="row">
              <div className="col-md-3 col-sm-12 text-center">
                <img className="mw-100 w-180px mb-3 border-round" src="https://res.cloudinary.com/carbonclick/image/upload/v1613084276/Enterprise/Round%20Theory%20/rt-quote_chc37t.png" />
              </div>
              <div className="col-md-9 col-sm-12 mobile-text-center text-left">
                <h5 className="mt-0 font-bold color-primary">"Like CarbonClick, we are passionate about sustainability and are constantly investing in new ways to reduce the environmental impact of our operations. CarbonClick have reimagined what carbon positivity looks like. Together, we have looked at the entire journey, from grape to glass, and have more than neutralised the carbon impact of our Round Theory wine. We love that!”</h5>
                <h5 className="mt-2 font-bold executive-signature">Simon Towns</h5>
                <p className="font-bold color-primary">Managing Director, Constellation Brands New Zealand</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="w-100 img-cover footer-img py-6" >
        <div className="container color-white">
          <p><b>Powered by</b></p>
          <div className="d-flex">
            <div>
              <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
              </a>
            </div>
            <div className="right">
              <div>
                <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                  <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                </a>
                <a href={footerLinks.instagram} target="_blank" rel="noopener noreferrer">
                  <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                </a>
                <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                  <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                </a>
              </div>
            </div>
          </div>
          <hr className="mb-4" />

          <div className="row">
            <div className="col-4">
              <div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.howItWorks} target="_blank" rel="noopener noreferrer">How it works</a></div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
              </div>
            </div>
            <div className="col-4">
              <div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
              </div>
            </div>
            <div className="col-4">
              <div>
                <div className="mb-3"><a className="color-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
